// src/components/dashboard/ManageAnnouncementModal.js
// Updated: 10/17/2025 12:51 PM

import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import Spinner from '../common/Spinner';
import ModalWrapper from '../common/ModalWrapper';

const ManageAnnouncementModal = ({ familyId, existingAnnouncement, onClose, onAnnouncementAdded }) => {
  const { userData } = useAuth();
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const isEditMode = !!existingAnnouncement;

  useEffect(() => { if (isEditMode && existingAnnouncement) { setTitle(existingAnnouncement.title); setMessage(existingAnnouncement.message); } }, [existingAnnouncement, isEditMode]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    const announcementData = { title, message, author: `${userData.firstName} ${userData.lastName}`, createdAt: isEditMode ? existingAnnouncement.createdAt : serverTimestamp(), updatedAt: serverTimestamp() };
    try {
      if (isEditMode) { await updateDoc(doc(db, `families/${familyId}/announcements/${existingAnnouncement.id}`), announcementData); toast.success('Announcement updated!'); } 
      else { await addDoc(collection(db, `families/${familyId}/announcements`), announcementData); toast.success('Announcement posted!'); }
      onAnnouncementAdded(); onClose();
    } catch (error) { console.error("Error saving announcement: ", error); toast.error('Failed to save announcement.'); } 
    finally { setLoading(false); }
  };

  return (
    <ModalWrapper onClose={onClose} size="lg">
      <div className="p-6 border-b"><h3 className="text-xl font-semibold text-neutral-gray">{isEditMode ? 'Edit Announcement' : 'New Announcement'}</h3></div>
      <form onSubmit={handleSubmit}>
        <div className="p-6 space-y-4">
          <div><label htmlFor="announcement-title" className="block text-sm font-medium text-gray-700">Title</label><input type="text" id="announcement-title" value={title} onChange={(e) => setTitle(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/></div>
          <div><label htmlFor="announcement-message" className="block text-sm font-medium text-gray-700">Message</label><textarea id="announcement-message" value={message} onChange={(e) => setMessage(e.target.value)} rows="4" required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"></textarea></div>
        </div>
        <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
          <button type="button" onClick={onClose} className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50">Cancel</button>
          <button type="submit" disabled={loading} className="px-4 py-2 bg-primary text-white rounded-md hover:bg-blue-700 text-sm font-medium disabled:opacity-50 flex items-center">{loading ? <Spinner size="sm" /> : isEditMode ? 'Save Changes' : 'Post Announcement'}</button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default ManageAnnouncementModal;